/* globals $ */
(function() {
    'use strict';
    var FaresFilter = {
        filtering: false,
        controller: '',
        longer_trips_shown: '',
        landing_times_shown: false,
        departure_zones_shown: false,
        airline_matrix_shown: false,
        flexible_matix_shown: false,
        widget_values: {},
        search_filters: {
            search_id: '',
            carriers: [],
            selected_pids: [],
            selected_fare_option: '',
            //cabins: [],
            page: '',
            segment_stops: [],
            departure_zones: [],
            //airline_option: [], // airline options from search page
            longer_trips: '',
            codeshare_dupes: '',
            ptc_type: '',
            fare_type: [],
            office_id: '',
            ticket_type: '',
            //show_hacker_fares : '',
            show_red_eye: '',
            specific_flights: [],
            min_duration: '',
            max_duration: '',
            layover_airports: [],
            connecting_airports: [],
            order_by: '',
            order_direction: '', // 'ASC' || 'DESC'
            currency: '',
            display_currency: '',
            fare_families: '',
            gds: []
        },
        sliders: [],
        init: function(controller, search_id, selected_package_ids, selected_fare_option, currency, display_currency) {
            this.controller = controller;

            this.search_filters.search_id = search_id;

            this.search_filters.selected_pids = selected_package_ids;

            this.search_filters.currency = currency;
            this.search_filters.display_currency = display_currency;

            if (selected_fare_option) {
                this.search_filters.selected_fare_option = selected_fare_option;
            }

            var faresSearchContent = $('#fares-search-content');
            var sideBanner = $('.side-banner');

            // MATRIX
            faresSearchContent.on('click', '#showMatrix a, .apply-carrier-filter', function(e) {
                e.preventDefault();
                FaresFilter.filterCarrierStops($(this).data('carrier'), $(this).data('stops'));
            });

            sideBanner.on('click', '.apply-carrier-filter', function(e){
                e.preventDefault();
                FaresFilter.filterCarrierStops($(this).data('carrier'), $(this).data('stops'));
            });

            faresSearchContent.on('click', 'input[name=fare_type]', function() {
                FaresFilter.filterFareTypes();
            });

            faresSearchContent.on('click', 'input[name=fare_families]', function() {
                FaresFilter.filterFareFamilies();
            });

            faresSearchContent.on('click', 'input[name=num_stops]', function() {
                FaresFilter.filterStops();
            });

            faresSearchContent.on('click', 'input[name=departure-zone]', function() {
                FaresFilter.filterDepartureZones();
            });

            faresSearchContent.on('click', 'input[name=carrier]', function() {
                FaresFilter.filterCarrier();
            });

            faresSearchContent.on(
                'click',
                'input[name=ticket_type]',
                function() {
                    FaresFilter.filterTicketType();
                }
            );

            faresSearchContent.on(
                'click',
                'input[name=office_id]',
                function() {
                    FaresFilter.filterOfficeId();
                }
            );

            faresSearchContent.on('click', 'input[name=connecting-airports]', function() {
                FaresFilter.filterConnectingAirports();
            });

            faresSearchContent.on('click', '.js-filter-select-all', function() {
                faresSearchContent.find('[name=' + $(this).data('field') + ']').prop('checked', true);
            });

            faresSearchContent.on('click', '.js-filter-select-none', function() {
                faresSearchContent.find('[name=' + $(this).data('field') + ']').prop('checked', false);
            });

            faresSearchContent.on('click', 'input[name=gds-radio]', function() {
                FaresFilter.filterGds();
            });
        },

        initSliders: function(widget_values) {
            this.widget_values = widget_values;

            // sliders
            if (this.widget_values) {
                //this.initTimeSliders();
                this.initDurationSlider();
            }
        },
        initSearchFilters: function(widget_values) {
            this.widget_values = widget_values;

            this.search_filters.order_by = this.widget_values.order_by;
            this.search_filters.order_direction = this.widget_values.order_direction;

            this.search_filters.longer_trips = this.widget_values.longer_trips;
            this.search_filters.codeshare_dupes = this.widget_values.codeshare_dupes;
            this.search_filters.show_red_eye = this.widget_values.show_red_eye;
            this.search_filters.page = this.widget_values.page;
            this.search_filters.fare_type = this.widget_values.fare_type;
            this.longer_trips_shown = this.search_filters.longer_trips === 1 && this.search_filters.codeshare_dupes === 1;
        },
        initDurationSlider: function() {
            // uncomment if departure and return sliders are required
            //var slider_index = this.widget_values.total_city_pairs*2;

            var slider_index = 0;

            this.sliders[slider_index] = new FaresFilter.Slider({
                selector: '#flight_duration',
                value_type: 'time',
                min_value: this.widget_values.min_duration,
                max_value: this.widget_values.max_duration,
                current_min_value: this.widget_values.current_min_duration,
                current_max_value: this.widget_values.current_max_duration
            });
        },
        filterCarrierStops: function(carrier_code, num_stops) {
            $('input[name=carrier]').each(function() {
                var checked = carrier_code === 'all' || carrier_code === $(this).val();
                $(this).prop('checked', checked);
            });

            $('input[name=num_stops]').each(function() {
                var checked = num_stops === 'all' || num_stops === parseInt($(this).val(), 10);
                $(this).prop('checked', checked);
            });

            this.filterStops();
            this.filterCarrier();
            this.filterPackages(1);
        },
        filterCarrier: function() {
            this.search_filters.carriers = [];
            var parent = this;

            $('input[name=carrier]:checked').each(function() {
                parent.search_filters.carriers.push($(this).val());
            });

            if (parent.search_filters.carriers.length === 0) {
                this.search_filters.carriers.push('-1');
            }
        },
        filterTicketType: function() {
            this.search_filters.ticket_type = $('input[name="ticket_type"]:checked').val();
        },
        filterOfficeId: function() {
            this.search_filters.office_id = $('input[name="office_id"]:checked').val();
        },
        filterConnectingAirports: function() {
            this.search_filters.connecting_airports = [];
            var parent = this;

            $('input[name=connecting-airports]:checked').each(function() {
                parent.search_filters.connecting_airports.push($(this).val());
            });

            if (parent.search_filters.connecting_airports.length === 0) {
                parent.search_filters.connecting_airports.push('-1');
            }
        },
        clearConnectingAirports: function() {
            var check = false;

            $('input[name=connecting-airports]').prop('checked', check);
            this.filterConnectingAirports();
        },
        resetConnectingAirports: function() {
            $('input[name=connecting-airports]').prop('checked', true);
        },
        checkAllCarriers: function(value) {
            var check = '';
            if (value === 'all') {
                check = true;
            } else if (value === 'none') {
                check = false;
            }

            $('input[name=carrier]').prop('checked', check);
            this.filterCarrier();
        },
        clearAllCarriers: function() {
            var check = false;

            $('input[name=carrier]').prop('checked', check);
            this.filterCarrier();
        },
        checkAllStops: function(value) {
            var check = '';
            if (value === 'all') {
                check = true;
            } else if (value === 'none') {
                check = false;
            }

            $('input[name=num_stops]').prop('checked', check);
            this.filterStops();

        },
        filterStops: function() {
            this.search_filters.segment_stops = [];
            var parent = this;
            $('input[name=num_stops]:checked').each(function() {
                parent.search_filters.segment_stops.push($(this).val());
            });

            if (parent.search_filters.segment_stops.length === 0) {
                parent.search_filters.segment_stops.push('-1');
            }
        },

        filterFareTypes: function() {
            this.search_filters.fare_type = [];
            var parent = this;
            $('input[name=fare_type]:checked').each(function() {
                parent.search_filters.fare_type.push($(this).val());
            });

            if (parent.search_filters.fare_type.length === 0) {
                parent.search_filters.fare_type.push('-1');
            }
        },
        resetFilterFareTypes: function() {

            $('input[name=fare_type]').prop('checked', true);

        },

        filterDepartureZones: function() {
            this.search_filters.departure_zones = [];
            var parent = this;
            $('input[name=departure-zone]:checked').each(function() {
                var city_pair = $(this).data('cp');
                var departure_zone = $(this).val();

                if (typeof parent.search_filters.departure_zones[city_pair] === 'undefined') {
                    parent.search_filters.departure_zones[city_pair] = [];
                }

                parent.search_filters.departure_zones[city_pair].push(departure_zone);
            });

            if (parent.search_filters.departure_zones.length === 0) {
                parent.search_filters.departure_zones.push(-1);
            } else {
                // additional check
                for (var i = 0; i < parent.search_filters.departure_zones.length; i++) {
                    if (typeof parent.search_filters.departure_zones[i] === 'undefined') {
                        parent.search_filters.departure_zones[i] = [-1];
                    }
                }
            }
        },

        filterFareFamilies: function() {
            this.search_filters.fare_families = $("input[name='fare_families']:checked").val();
        },


        filterGds : function() {
            this.search_filters.gds = $("input[name='gds-radio']:checked").val();
        },

        checkSpecificDepartureTimes: function(departure_group_id) {
            $('#' + departure_group_id).find('input[name=departure-zone]').prop('checked', true);
            this.filterDepartureZones();
        },
        resetDepartureTimes: function() {
            $('input[name=departure-zone]').prop('checked', true);
        },
        resetDurationSlider: function() {
            // Uncomment when using time sliders
            // var slider_index = this.widget_values.total_city_pairs*2

            var slider_index = 0;

            this.sliders[slider_index].reset();
            if (parent.widget_values && parent.widget_values.min_duration) {
                this.search_filters.min_duration = parent.widget_values.min_duration;
            } else {
                // this.search_filters.min_duration = 49500;
                this.search_filters.min_duration = 0;
            }

            if (parent.widget_values && parent.widget_values.max_duration) {
                this.search_filters.max_duration = parent.widget_values.max_duration;
            } else {
                // this.search_filters.max_duration = 146700;
                this.search_filters.max_duration = 0;
            }
        },
        resetAllFilters: function(stopReset) {
            this.resetConnectingAirports();
            this.filterConnectingAirports();
            this.checkAllCarriers('all');
            this.checkAllStops('all');
            this.resetDepartureTimes();
            this.resetFilterFareTypes();
            this.filterFareTypes();
            this.filterDepartureZones();
            this.resetDurationSlider();

            $('#fares-search-left-sidebar input').prop('checked', true);

            $('#maximum_connections').val('default');
            $('#ticket-type-all').prop('checked', true);
            $('#office-id-all').prop('checked', true);
            $('#fare-families-normal').prop('checked', true);

            this.filterOfficeId();
            this.filterTicketType();
            this.filterFareFamilies();

            this.filterPackages(1);

            this.search_filters.specific_flights = [];
        },
        filterPackages: function(page) {
            var parent = this;

            // filtering lock
            if (parent.filtering) {
                return false;
            } else {
                parent.filtering = true;
            }

            var modal = $('#loading_filter');
            var modalShown = false;
            var shouldAutoDismissModal = false;
            modal.on('shown.bs.modal', function() {
                modal.off('shown.bs.modal');
                modalShown = true;
                if (shouldAutoDismissModal) {
                    modal.modal('hide');
                }
            }).modal('show');

            if (page) {
                this.search_filters.page = page;
            }

            $.ajax({
                url: '/' + parent.controller + '/filter',
                data: parent.search_filters,
                type: 'post',
                dataType: 'json',
                success: function(data) {
                    // remove lock
                    parent.filtering = false;

                    if (modalShown) {
                        modal.modal('hide');
                    } else {
                        shouldAutoDismissModal = true;
                    }

                    if (!data.result) {
                        return;
                    }

                    //closing the flexible dates matrix
                    FaresFilter.flexible_matix_shown = false;

                    //updating results
                    //$('#fares-search-results').html(data.html.results);

                    // Not created for 2 steps
                    if (data.html.sorting_options) {
                        $('#fares-search-sorting-options').html(data.html.sorting_options);
                    }

                    $('#fares-search-package-list').html(data.html.result_packages);
                    $('#fares-search-paging').html(data.html.results_paging);

                    // fix the toggling
                    window.refreshToggling();
                },
                error: function(result) {
                    $('#loading_filter').modal('hide');

                    // remove lock
                    parent.filtering = false;
                }
            });
        },
        getDurationString: function(seconds) {
            var hours = Math.floor(seconds / 3600);
            var minutes = Math.floor((seconds / 60) % 60);
            return hours + 'h' + (minutes ? (' ' + minutes + 'm') : ' 00m');
        },

        /**
         *  Applies Jquery UI sliders.
         *
         *  Initialization params:
         *   {
    *       selector    : required (string) jquery selector of the slider wrapper,
    *       value_type  : required 'hour' (string) 'hour' | 'time' | 'price',
    *       min_value   : required (mixed),
    *       max_value   : required (mixed)
    *   }
         *
         *  Json response expected values:
         *   {result : (bool) [, feedback_message : (string)]}
         */
        Slider: function(params) {
            this.selector = '';
            this.options = [];
            this.value_type = '';
            this.default_display_values = [];
            this.current_min_value = '';
            this.current_max_value = '';
            this.reset_min_value = '';
            this.reset_max_value = '';

            this.init = function(params) {
                this.selector = params.selector;
                this.value_type = params.value_type;
                var parent = this;
                this.options = {
                    min: params.min_value,
                    max: params.max_value,
                    current_min: params.current_min_value ? params.current_min_value : params.min_value,
                    current_max: params.current_max_value ? params.current_max_value : params.max_value,
                    reset_min_value: params.reset_min_value ? params.reset_min_value : params.current_min_value,
                    reset_max_value: params.reset_max_value ? params.reset_max_value : params.current_max_value
                };

                this.value_type = params.value_type;

                // set options depending on the type
                if (params.value_type === 'hour') {
                    this.options.range = true;
                    this.options.values = [this.options.current_min, this.options.current_max];
                    this.options.min = 0;
                    this.options.step = 1;
                    this.default_display_values[0] = FaresFilter.widget_values.hours_ampm[this.options.reset_min_value];
                    this.default_display_values[1] = FaresFilter.widget_values.hours_ampm[this.options.reset_max_value];

                    parent = this;
                    this.options.slide = function(event, ui) {
                        var minval_obj = $(parent.selector).parent().find('.min_value');
                        var maxval_obj = $(parent.selector).parent().find('.max_value');

                        $(minval_obj).val(FaresFilter.widget_values.hours_ampm[ui.values[0]]);
                        $(maxval_obj).val(FaresFilter.widget_values.hours_ampm[ui.values[1]]);

                        FaresFilter.search_filters[$(minval_obj).attr('min')] = FaresFilter.widget_values.hours[ui.values[0]];
                        FaresFilter.search_filters[$(maxval_obj).attr('max')] = FaresFilter.widget_values.hours[ui.values[1]];
                    };
                } else if (params.value_type === 'time') {
                    this.options.range = true;
                    this.options.values = [this.options.current_min, this.options.current_max];
                    this.default_display_values[0] = FaresFilter.getDurationString(this.options.min);
                    this.default_display_values[1] = FaresFilter.getDurationString(this.options.max);

                    if (this.options.max - this.options.min > 600 * 6) {
                        // 15 mins step
                        this.options.step = 900;
                    } else {
                        // 1 min step
                        this.options.step = 60;
                    }

                    parent = this;
                    this.options.slide = function(event, ui) {
                        // get the duration string
                        $(parent.selector).parent().find('.min_value').val(FaresFilter.getDurationString(ui.values[0]));
                        $(parent.selector).parent().find('.max_value').val(FaresFilter.getDurationString(ui.values[1]));

                        FaresFilter.search_filters.min_duration = ui.values[0];
                        FaresFilter.search_filters.max_duration = ui.values[1];
                    };
                } else {
                    return;
                }

                $(this.selector).slider(this.options);
            };

            this.reset = function() {
                $(this.selector).parent().find('.min_value').val(this.default_display_values[0]);
                $(this.selector).parent().find('.max_value').val(this.default_display_values[1]);

                if (typeof this.options.values !== 'undefined') {
                    $(this.selector).slider('values', [this.options.reset_min_value, this.options.reset_max_value]);
                } else {
                    $(this.selector).slider('value', this.options.reset_max_value);
                }
            };

            // initialize the object
            this.init(params);
        }
    };
    window.FaresFilter = FaresFilter;
})();